import AppBar from "@material-ui/core/AppBar"
import Button from "@material-ui/core/Button"
import { fade, makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
/*import { Button, Navbar, Nav, NavDropdown } from 'react-bootstrap';


import './styles.css';*/
import LocationOnIcon from "@material-ui/icons/LocationOn"
import WhatsAppIcon from "@material-ui/icons/WhatsApp"
import { useContext } from "react"
import { RiArrowLeftLine } from "react-icons/ri"
import { useHistory } from "react-router-dom"
import { LoginDialogContext } from "../../components/LoginDialog"
import SiteContext from "../../contexts/SiteContext"
import { TextosContext } from "../../contexts/TextosContext"
import { identificarEstabelecimentoSelecionado } from "../../services/functions"

const useStyles = makeStyles(theme => ({
    root: {
        position: "fixed",
        flexGrow: "1",
        top: "0",
        width: "100%",
        zIndex: "999",
        cursor: "pointer",
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        textTransform: "capitalize",
        flexGrow: 1,
        display: "block",
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
    },
    titleProduto: {
        textTransform: "uppercase",
        position: "absolute",
        right: 0,
        flexGrow: 0,
        display: "block",
        [theme.breakpoints.up("sm")]: {
            display: "block",
        },
    },
    search: {
        position: "relative",
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        "&:hover": {
            width: "auto",
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: "150px",
        [theme.breakpoints.up("lg")]: {
            marginLeft: theme.spacing(1),
            width: "auto",
        },
    },
    voltarIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        left: "0",
        fontSize: "1.5rem",
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: "100%",
        position: "absolute",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    inputRoot: {
        color: "inherit",
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            width: "12ch",
            "&:focus": {
                width: "20ch",
            },
        },
    },
}))

export default function Cabecalho(props) {
    const history = useHistory()

    const { mostrarWhatsapp } = props

    const {
        aplicativoDados,
        setAplicativoDados,

        estabelecimentoAtual,
        setEstabelecimentoAtual,

        usuarioLogado,
        setUsuarioLogado,

        setLoading,
    } = useContext(SiteContext)
    const { textos } = useContext(TextosContext)
    const { setAbrirDialogLogin } = useContext(LoginDialogContext)

    const aberto = estabelecimentoAtual?.online

    const desconctarMesa = () => {
        setLoading(true)
        localStorage.clear()
        window.location.href = window.location.origin
    }

    const classes = useStyles()
    if (props.visualizacao) {
        return (
            <div className={classes.root} id="cabecalhoApp">
                <AppBar position="static" className="cabecalhoApp" id="cabecalhoApp2">
                    <Toolbar className="container">
                        <Typography className={classes.title} variant="h6" noWrap>
                            {textos.cardapio}
                            {estabelecimentoAtual
                                ? estabelecimentoAtual.nomeAlternativo
                                    ? estabelecimentoAtual.nomeAlternativo
                                    : estabelecimentoAtual.nome
                                : aplicativoDados.projectName}
                        </Typography>
                    </Toolbar>
                </AppBar>
            </div>
        )
    } else if (usuarioLogado?.logado) {
        return (
            <div className={classes.root} id="cabecalhoApp">
                <AppBar position="static" className="cabecalhoApp" id="cabecalhoApp2">
                    <Toolbar className="container">
                        {props.mesaHistorico ? (
                            <>
                                <div
                                    className={classes.voltarIcon}
                                    color="inherit"
                                    onClick={() => history.goBack()}
                                    aria-label="open drawer"
                                >
                                    <RiArrowLeftLine></RiArrowLeftLine>
                                </div>
                                <Typography
                                    className={classes.titleProduto}
                                    style={{ width: "calc( 100% - 57px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {props.mesaHistorico}
                                </Typography>
                            </>
                        ) : null}

                        {props.mesa ? (
                            <>
                                <Typography
                                    className={classes.title}
                                    variant="h6"
                                    noWrap
                                    style={{ textTransform: "uppercase" }}
                                >
                                    {props.mesa}
                                </Typography>

                                {aplicativoDados.permitirDesconectarMesa ? (
                                    <Button
                                        variant="contained"
                                        style={{ background: "#28a745", color: "white" }}
                                        onClick={() => {
                                            desconctarMesa()
                                        }}
                                    >
                                        {textos.desconectar}
                                    </Button>
                                ) : null}
                            </>
                        ) : null}

                        {props.statusEstabelecimento &&
                        props.nomeEstabelecimentoCardapio &&
                        !mostrarWhatsapp ? (
                            <>
                                <Typography className={classes.title} variant="h6" noWrap>
                                    {estabelecimentoAtual
                                        ? estabelecimentoAtual.nomeAlternativo
                                            ? estabelecimentoAtual.nomeAlternativo
                                            : estabelecimentoAtual.nome
                                        : aplicativoDados.projectName}
                                </Typography>
                                <Button
                                    variant="contained"
                                    style={
                                        aberto ?? true
                                            ? estabelecimentoAtual.pausado
                                                ? { background: "#ffc107", color: "black" }
                                                : { background: "#28a745", color: "white" }
                                            : { background: "#dc3545", color: "white" }
                                    }
                                >
                                    {aberto ?? true
                                        ? estabelecimentoAtual.pausado
                                            ? textos.pausado
                                            : textos.aberto
                                        : textos.fechado}
                                </Button>
                            </>
                        ) : null}

                        {props.nomeEstabelecimentoCardapio && mostrarWhatsapp ? (
                            <>
                                <Typography className={classes.title} variant="h6" noWrap>
                                    {estabelecimentoAtual
                                        ? estabelecimentoAtual.nomeAlternativo
                                            ? estabelecimentoAtual.nomeAlternativo
                                            : estabelecimentoAtual.nome
                                        : aplicativoDados.projectName}
                                </Typography>
                                <Button
                                    variant="contained"
                                    style={{
                                        background: "#28a745",
                                        color: "white",
                                        marginRight: "10px",
                                    }}
                                    onClick={() => {
                                        window.open(
                                            `https://wa.me/55${estabelecimentoAtual.numeroWhatsapp.replace(
                                                /([^\d])+/gim,
                                                ""
                                            )}`,
                                            "_blank"
                                        )
                                        // window.open(`https://wa.me/55${mostrarWhatsapp.replace(/([^\d])+/gim, '')}`, '_blank')
                                    }}
                                >
                                    <WhatsAppIcon style={{ marginRight: "10px" }} /> whatsapp
                                </Button>
                                <Button
                                    variant="contained"
                                    style={
                                        aberto ?? true
                                            ? estabelecimentoAtual.pausado
                                                ? { background: "#ffc107", color: "black" }
                                                : { background: "#28a745", color: "white" }
                                            : { background: "#dc3545", color: "white" }
                                    }
                                >
                                    {aberto ?? true
                                        ? estabelecimentoAtual.pausado
                                            ? textos.pausado
                                            : textos.aberto
                                        : textos.fechado}
                                </Button>
                            </>
                        ) : null}

                        {props.nomeUsuario ? (
                            <>
                                <Typography className={classes.title} variant="h6" noWrap>
                                    {usuarioLogado.cliente ? usuarioLogado.cliente.nome : ""}
                                </Typography>
                            </>
                        ) : null}

                        {props.nomeUsuarioFidelidade ? (
                            <>
                                <Typography
                                    className={classes.titleProduto}
                                    style={{ width: "calc( 100% - 57px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {usuarioLogado.cliente ? usuarioLogado.cliente.nome : ""}
                                </Typography>
                            </>
                        ) : null}

                        {/* NOME */}
                        {props.produtoNome && props.voltarApenasFidelidade ? (
                            <>
                                <div
                                    edge="start"
                                    className={classes.voltarIcon}
                                    color="inherit"
                                    onClick={() => history.goBack()}
                                    aria-label="open drawer"
                                >
                                    <RiArrowLeftLine></RiArrowLeftLine>
                                </div>
                                <Typography
                                    className={classes.titleProduto}
                                    style={{ width: "calc( 100% - 57px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {props.produtoNome}
                                </Typography>
                            </>
                        ) : null}

                        {!props.produtoNome && props.voltarApenasFidelidade ? (
                            <div
                                edge="start"
                                className={classes.voltarIcon}
                                color="inherit"
                                onClick={() => history.goBack()}
                                aria-label="open drawer"
                            >
                                <RiArrowLeftLine></RiArrowLeftLine>
                            </div>
                        ) : null}

                        {props.nomeEstabelecimentoLojas ? (
                            <>
                                <Typography
                                    className={classes.title}
                                    style={{ width: "calc( 100% - 125px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {aplicativoDados.projectName}
                                </Typography>
                                <Button
                                    variant="contained"
                                    onClick={() =>
                                        history.push(
                                            `/delivery/enderecos${identificarEstabelecimentoSelecionado(
                                                aplicativoDados
                                            )}`
                                        )
                                    }
                                >
                                    <LocationOnIcon />
                                    {textos.enderecos}
                                </Button>
                            </>
                        ) : null}

                        {props.produtoNome && props.voltar ? (
                            <>
                                <div
                                    className={classes.voltarIcon}
                                    color="inherit"
                                    onClick={() => history.goBack()}
                                    aria-label="open drawer"
                                >
                                    <RiArrowLeftLine></RiArrowLeftLine>
                                </div>
                                <Typography
                                    className={classes.titleProduto}
                                    style={{ width: "calc( 100% - 57px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {props.produtoNome}
                                </Typography>
                            </>
                        ) : null}
                    </Toolbar>
                </AppBar>
            </div>
        )
    } else {
        return (
            <div className={classes.root} id="cabecalhoApp">
                <AppBar position="static" className="cabecalhoApp" id="cabecalhoApp2">
                    <Toolbar className="container">
                        {props.produtoNome && props.voltar ? (
                            <>
                                <div
                                    className={classes.voltarIcon}
                                    color="inherit"
                                    onClick={() => history.goBack()}
                                    aria-label="open drawer"
                                >
                                    <RiArrowLeftLine></RiArrowLeftLine>
                                </div>

                                <Typography
                                    className={classes.titleProduto}
                                    style={{ width: "calc( 100% - 57px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {props.produtoNome}
                                </Typography>
                            </>
                        ) : null}

                        {props.clienteFielStart ? (
                            <>
                                <Typography
                                    className={classes.title}
                                    style={{ width: "calc( 100% - 125px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {estabelecimentoAtual
                                        ? estabelecimentoAtual.nomeAlternativo
                                            ? estabelecimentoAtual.nomeAlternativo
                                            : estabelecimentoAtual.nome
                                        : aplicativoDados.projectName}
                                </Typography>
                            </>
                        ) : null}

                        {props.nomeEstabelecimentoCardapio ? (
                            <>
                                <Typography
                                    className={classes.title}
                                    style={{ width: "calc( 100% - 125px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {estabelecimentoAtual
                                        ? estabelecimentoAtual.nomeAlternativo
                                            ? estabelecimentoAtual.nomeAlternativo
                                            : estabelecimentoAtual.nome
                                        : aplicativoDados.projectName}
                                </Typography>

                                {mostrarWhatsapp ? (
                                    <>
                                        <Button
                                            variant="contained"
                                            style={{
                                                background: "#28a745",
                                                color: "white",
                                                marginRight: "10px",
                                            }}
                                            onClick={() => {
                                                window.open(
                                                    `https://wa.me/55${estabelecimentoAtual.numeroWhatsapp.replace(
                                                        /([^\d])+/gim,
                                                        ""
                                                    )}`,
                                                    "_blank"
                                                )
                                                // window.open(`https://wa.me/55${mostrarWhatsapp.replace(/([^\d])+/gim, '')}`, '_blank')
                                            }}
                                        >
                                            <WhatsAppIcon style={{ marginRight: "10px" }} />{" "}
                                            {textos.whatsapp}
                                        </Button>
                                    </>
                                ) : null}

                                <Button
                                    variant="contained"
                                    style={
                                        aberto ?? true
                                            ? estabelecimentoAtual.pausado
                                                ? { background: "#ffc107", color: "black" }
                                                : { background: "#28a745", color: "white" }
                                            : { background: "#dc3545", color: "white" }
                                    }
                                >
                                    {aberto ?? true
                                        ? estabelecimentoAtual.pausado
                                            ? textos.pausado
                                            : textos.aberto
                                        : textos.fechado}
                                </Button>
                            </>
                        ) : null}

                        {props.nomeEstabelecimentoLojas ? (
                            <>
                                <Typography
                                    className={classes.title}
                                    style={{ width: "calc( 100% - 125px)" }}
                                    variant="h6"
                                    noWrap
                                >
                                    {aplicativoDados.projectName}
                                </Typography>
                                <Button
                                    variant="contained"
                                    onClick={() => setAbrirDialogLogin(true)}
                                    style={{ background: "#28a745", color: "white" }}
                                >
                                    Fazer Login
                                </Button>
                            </>
                        ) : null}
                    </Toolbar>
                </AppBar>
            </div>
        )
    }
}
